import { getFrequencyLabel } from "library/get-frequency-label.mjs"
import { AuthoringAmendsType } from "authoring/lib/enum/authoring-amends-type.mjs"

export function normaliseAuthoringAmendsAuditFrequency(data) {
    if (!Array.isArray(data)) return data

    data.forEach((entry) => {
        if (entry?.type !== AuthoringAmendsType.AUTHORING_AMENDS) return
        entry.payload = normaliseAuthoringAmendsAuditPayload(entry?.payload)
    })

    return data
}

export function normaliseAuthoringAmendsAuditPayload(payload) {
    if (!payload || typeof payload !== "object") return payload

    return {
        ...payload,
        original: normaliseFrequencyObject(payload.original),
        tailored: normaliseFrequencyObject(payload.tailored),
    }
}

function normaliseFrequencyObject(obj) {
    if (!obj?.frequency) return obj
    return { ...obj, frequency: toFrequencyValue(obj.frequency) }
}

function toFrequencyValue(frequency) {
    if (!frequency) return frequency
    if (typeof frequency === "string") return { label: frequency }
    if (typeof frequency === "object") {
        if ("label" in frequency) return { label: toLabel(frequency.label) }
        if ("frequency" in frequency) return { label: toLabel(frequency.frequency) }
        if ("period" in frequency && "interval" in frequency) return { label: getFrequencyLabel(frequency) }
    }
    return { label: String(frequency) }
}

function toLabel(frequency) {
    if (!frequency) return frequency
    if (typeof frequency === "string") return frequency
    if (typeof frequency === "object") {
        if ("label" in frequency) return toLabel(frequency.label)
        if ("frequency" in frequency) return toLabel(frequency.frequency)
        if ("period" in frequency && "interval" in frequency) return getFrequencyLabel(frequency)
    }
    return String(frequency)
}
